"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Arguments = void 0;
__exportStar(require("./payment-message"), exports);
var Arguments;
(function (Arguments) {
    var OnCloseStatus;
    (function (OnCloseStatus) {
        /**
         * The payment was successful and user closed popup via "back to merchant" button
         */
        OnCloseStatus["Success"] = "success";
        /**
         * The payment was unsuccessful and user closed popup via "back to merchant" button
         * or
         * The payment was cancelled via "cancel" button
         */
        OnCloseStatus["Failure"] = "failure";
        /**
         * The popup was closed on 'x' button click, there is no way to check if payment was successful or not
         */
        OnCloseStatus["Unknown"] = "unknown";
    })(OnCloseStatus = Arguments.OnCloseStatus || (Arguments.OnCloseStatus = {}));
})(Arguments = exports.Arguments || (exports.Arguments = {}));
